// 语言映射表
export const langMap = {
  en: {
    en: "English",
    "zh-cn": "Chinese (Simplified)",
    "zh-tw": "Chinese (Traditional)",
    fr: "French",
    de: "German",
    es: "Spanish",
    pt: "Portuguese",
    it: "Italian",
    nl: "Dutch",
    ja: "Japanese",
    da: "Danish",
    sv: "Swedish",
    el: "Greek",
    pl: "Polish",
    hu: "Hungarian",
    ro: "Romanian",
  },
  "zh-cn": {
    en: "英语",
    "zh-cn": "中文(简体)",
    "zh-tw": "中文(繁体)",
    fr: "法语",
    de: "德语",
    es: "西班牙语",
    pt: "葡萄牙语",
    it: "意大利语",
    nl: "荷兰语",
    ja: "日语",
    da: "丹麦语",
    sv: "瑞典语",
    el: "希腊语",
    pl: "波兰语",
    hu: "匈牙利语",
    ro: "罗马尼亚语",
  },
  "zh-tw": {
    en: "英語",
    "zh-cn": "中文(簡體)",
    "zh-tw": "中文(繁體)",
    fr: "法語",
    de: "德語",
    es: "西班牙語",
    pt: "葡萄牙語",
    it: "意大利語",
    nl: "荷蘭語",
    ja: "日語",
    da: "丹麥語",
    sv: "瑞典語",
    el: "希臘語",
    pl: "波蘭語",
    hu: "匈牙利語",
    ro: "羅馬尼亞語",
  },
  fr: {
    en: "Anglais",
    "zh-cn": "Chinois (Simplifié)",
    "zh-tw": "Chinois (Traditionnel)",
    fr: "Français",
    de: "Allemand",
    es: "Espagnol",
    pt: "Portugais",
    it: "Italien",
    nl: "Néerlandais",
    ja: "Japonais",
    da: "Danois",
    sv: "Suédois",
    el: "Grec",
    pl: "Polonais",
    hu: "Hongrois",
    ro: "Roumain",
  },
  de: {
    en: "Englisch",
    "zh-cn": "Chinesisch (Vereinfacht)",
    "zh-tw": "Chinesisch (Traditionell)",
    fr: "Französisch",
    de: "Deutsch",
    es: "Spanisch",
    pt: "Portugiesisch",
    it: "Italienisch",
    nl: "Niederländisch",
    ja: "Japanisch",
    da: "Dänisch",
    sv: "Schwedisch",
    el: "Griechisch",
    pl: "Polnisch",
    hu: "Ungarisch",
    ro: "Rumänisch",
  },
  es: {
    en: "Inglés",
    "zh-cn": "Chino (Simplificado)",
    "zh-tw": "Chino (Tradicional)",
    fr: "Francés",
    de: "Alemán",
    es: "Español",
    pt: "Portugués",
    it: "Italiano",
    nl: "Neerlandés",
    ja: "Japonés",
    da: "Danés",
    sv: "Sueco",
    el: "Griego",
    pl: "Polaco",
    hu: "Húngaro",
    ro: "Rumano",
  },
  pt: {
    en: "Inglês",
    "zh-cn": "Chinês (Simplificado)",
    "zh-tw": "Chinês (Tradicional)",
    fr: "Francês",
    de: "Alemão",
    es: "Espanhol",
    pt: "Português",
    it: "Italiano",
    nl: "Holandês",
    ja: "Japonês",
    da: "Dinamarquês",
    sv: "Sueco",
    el: "Grego",
    pl: "Polonês",
    hu: "Húngaro",
    ro: "Romeno",
  },
  it: {
    en: "Inglese",
    "zh-cn": "Cinese (Semplificato)",
    "zh-tw": "Cinese (Tradizionale)",
    fr: "Francese",
    de: "Tedesco",
    es: "Spagnolo",
    pt: "Portoghese",
    it: "Italiano",
    nl: "Olandese",
    ja: "Giapponese",
    da: "Danese",
    sv: "Svedese",
    el: "Greco",
    pl: "Polacco",
    hu: "Ungherese",
    ro: "Rumeno",
  },
  nl: {
    en: "Engels",
    "zh-cn": "Chinees (Vereenvoudigd)",
    "zh-tw": "Chinees (Traditioneel)",
    fr: "Frans",
    de: "Duits",
    es: "Spaans",
    pt: "Portugees",
    it: "Italiaans",
    nl: "Nederlands",
    ja: "Japans",
    da: "Deens",
    sv: "Zweeds",
    el: "Grieks",
    pl: "Pools",
    hu: "Hongaars",
    ro: "Roemeens",
  },
  ja: {
    en: "英語",
    "zh-cn": "中国語（簡体字）",
    "zh-tw": "中国語（繁体字）",
    fr: "フランス語",
    de: "ドイツ語",
    es: "スペイン語",
    pt: "ポルトガル語",
    it: "イタリア語",
    nl: "オランダ語",
    ja: "日本語",
    da: "デンマーク語",
    sv: "スウェーデン語",
    el: "ギリシャ語",
    pl: "ポーランド語",
    hu: "ハンガリー語",
    ro: "ルーマニア語",
  },
  da: {
    en: "Engelsk",
    "zh-cn": "Kinesisk (forenklet)",
    "zh-tw": "Kinesisk (traditionelt)",
    fr: "Fransk",
    de: "Tysk",
    es: "Spansk",
    pt: "Portugisisk",
    it: "Italiensk",
    nl: "Hollandsk",
    ja: "Japansk",
    da: "Dansk",
    sv: "Svensk",
    el: "Græsk",
    pl: "Polsk",
    hu: "Ungarsk",
    ro: "Rumænsk",
  },
  sv: {
    en: "Engelska",
    "zh-cn": "Kinesiska (förenklad)",
    "zh-tw": "Kinesiska (traditionell)",
    fr: "Franska",
    de: "Tyska",
    es: "Spanska",
    pt: "Portugisiska",
    it: "Italienska",
    nl: "Nederländska",
    ja: "Japanska",
    da: "Danska",
    sv: "Svenska",
    el: "Grekiska",
    pl: "Polska",
    hu: "Ungerska",
    ro: "Rumänska",
  },
  el: {
    en: "Αγγλικά",
    "zh-cn": "中文（简体）",
    "zh-tw": "中文（繁體）",
    fr: "Γαλλικά",
    de: "Γερμανικά",
    es: "Ισπανικά",
    pt: "Πορτογαλικά",
    it: "Ιταλικά",
    nl: "Ολλανδικά",
    ja: "Ιαπωνικά",
    da: "Δανικά",
    sv: "Σουηδικά",
    el: "Ελληνικά",
    pl: "Πολωνικά",
    hu: "Ουγγρικά",
    ro: "Ρουμανικά",
  },
  pl: {
    en: "Angielski",
    "zh-cn": "Chiński (uproszczony)",
    "zh-tw": "Chiński (tradycyjny)",
    fr: "Francuski",
    de: "Niemiecki",
    es: "Hiszpański",
    pt: "Portugalski",
    it: "Włoski",
    nl: "Holenderski",
    ja: "Japoński",
    da: "Duński",
    sv: "Szwedzki",
    el: "Grecki",
    pl: "Polski",
    hu: "Węgierski",
    ro: "Rumuński",
  },
  hu: {
    en: "Angol",
    "zh-cn": "Kínai (egyszerűsített)",
    "zh-tw": "Kínai (hagyományos)",
    fr: "Francia",
    de: "Német",
    es: "Spanyol",
    pt: "Portugál",
    it: "Olasz",
    nl: "Holland",
    ja: "Japán",
    da: "Dán",
    sv: "Svéd",
    el: "Görög",
    pl: "Lengyel",
    hu: "Magyar",
    ro: "Román",
  },
  ro: {
    en: "Engleză",
    "zh-cn": "Chineză (simplificată)",
    "zh-tw": "Chineză (tradițională)",
    fr: "Franceză",
    de: "Germană",
    es: "Spaniolă",
    pt: "Portugheză",
    it: "Italiană",
    nl: "Olandeză",
    ja: "Japoneză",
    da: "Daneză",
    sv: "Suedeză",
    el: "Greacă",
    pl: "Poloneză",
    hu: "Maghiară",
    ro: "Română",
  },
};
